/**
 * 「やってはいけないこと」の文言（v3で新規に書き起こしたもの）。
 *
 * モックv3の05節には「やってはいけないこと」の枠があるが、DB07 が持っているのは
 * 07-余力-注記（全社の余力が3.0未満のときの注記）だけで、余力を測る設問が
 * 現行の74問に無いため使えない。そこで PI-1 のテーマごとに、その打ち手の
 * 「裏返し」を1〜2文で用意した。
 *
 * 【書き方の決まり（DBの文言ルールに合わせる）】
 *  - 断定を避け「〜しやすい」「〜になりがち」で止める
 *  - 原因を個人に置かない。主語は組織・仕組み・体制
 *  - 4軸の値そのものを改善目標にしない（07-RULE-ハーマン / 09-RULE-改善禁止）
 *
 * DB化するときは DB07 に「やってはいけないこと」欄を足して、そちらへ移す。
 */
import type { PiTheme } from './orgImprovementV3';

export const DONT_DO_BY_THEME: Record<PiTheme, string> = {
  集中解消:
    'その人の負担を減らそうとして、新しい仕組みやルールを増やすことです。増やすほど覚えることが増え、結局その人に聞くことになりやすい状態です。足すより先に、いま1人に寄っているものを1つ動かすほうが実行されやすくなります。',
  役割権限:
    '決めてよい範囲を口頭だけで伝えることです。書かれていないと、迷ったときに結局確認が入ります。3つだけでよいので、書いて渡してください。',
  橋渡し:
    '「部署間でもっと連携しよう」と全体に呼びかけることです。呼びかけは担当が決まらないため動きません。仕事を1つ選び、両部署から1名ずつ名前を出すところまで決めてください。',
  管理職:
    '管理職に新しい役割を足すことです。相談を受ける時間は、何かを外さないと生まれません。足す前に、外せる業務を1つ決めてください。',
  人物評価:
    '評価や改善点の話から入ることです。身構えられると本音が出ず、かえって距離が開きやすくなります。持ち味の話だけで30分にしてください。',
  採用配置:
    '「良い人がいれば採る」と条件を決めずに動くことです。決めずに選ぶと、いまと似た持ち味の人が集まりやすい傾向があります。先に足りない持ち味を言葉にしてください。',
  KPI: '数字を増やして共有することです。数が増えるほど、どれを見ればよいか分からなくなります。1つだけ選んで、毎週同じものを共有してください。',
};
